import styled from "@emotion/styled/macro";

const ResetButton = styled("button")`
  border: none;
  background: none;
`;

export default ResetButton;
